export default __webpack_public_path__ + "static/national-metric-desktop-626eebb2cf12c70c679a335dd8ba4b8c.svg";